import { render } from "./MoveToBagModal.vue?vue&type=template&id=63f57f1c&scoped=true"
import script from "./MoveToBagModal.vue?vue&type=script&lang=js"
export * from "./MoveToBagModal.vue?vue&type=script&lang=js"

import "./MoveToBagModal.vue?vue&type=style&index=0&id=63f57f1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f57f1c"]])

export default __exports__